export const environment = {
  production: true,
  env: "test",
  firebaseConfig: {
    apiKey: "AIzaSyBe3ru9QcSCqBSGUqtNTdxcV9_Ykbee4f0",
    authDomain: "heatpuls.firebaseapp.com",
    databaseURL: "https://heatpuls.firebaseio.com",
    projectId: "heatpuls",
    storageBucket: "heatpuls.appspot.com",
    messagingSenderId: "830768269092",
    appId: "1:830768269092:web:545702ea7400e90c77d5b1",
  },
  BACKEND_BASE_URL: "/d/",
  AI_URL: "/ai/",
  SUBSIDY_APPLY_URL: "https://energieklus.nl/subsidie-aanvragen",
  SUBSIDY_APPLY_LINK_TEXT: "energieklus.nl/subsidie-aanvragen",
  SUBSIDY_PORTAL_BASE_URL: "https://subsidie.sobolt.com",
  version: "energieklus@" + "no-ai-sneltoets", // NOTE: DO NOT MODIFY: Updated with no-ai-sneltoets during build process
};
